import script from "./TheLog.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__